module.exports = __webpack_public_path__ + "static/media/beaconhill-min.44be2725.jpg";